/**
 * bx-forms — canonical EAS GetApp brand exports
 */

// biome-ignore lint/performance/noBarrelFile: Package entrypoints intentionally define the branded public API surface.
export {
  InlineForm,
  type InlineFormProps,
  type InlineFormTemplate,
  DEFAULT_QUALIFICATION_OPTIONS,
  MinimalInlineForm,
  type MinimalInlineFormProps,
  type InlineFormVariant,
} from './InlineForm';
export type { CardBackground } from '../../react/components/FormCard';
export {
  ModalForm,
  type ModalFormProps,
  type ButtonPlacement,
  type EmailStepRenderProps,
  type QualificationStepConfig,
  type QualificationStepRenderProps,
  GETAPP_MODAL_BRAND_CONFIG,
} from './ModalForm';
export {
  MultiFieldInlineForm,
  type MultiFieldInlineFormProps,
  type FieldConfig,
  GETAPP_MULTI_FIELD_BRAND_CONFIG,
  // Field presets
  JOB_FUNCTION_OPTIONS,
  SENIORITY_OPTIONS,
  SINGLE_STEP_2_FIELDS,
  SINGLE_STEP_3_FIELDS,
  SINGLE_STEP_4_FIELDS,
  TWO_STEP_DEFAULT_FIELDS,
} from './MultiFieldInlineForm';
export type { FieldLayout } from '../../react/MultiFieldInlineForm';

// GetApp-specific qualification options
export const GETAPP_ORGANIZATION_TYPE_OPTIONS = [
  'Freelancer',
  'Small Business',
  'Mid Size Business',
  'Large Enterprise',
  'Non Profit',
  'Public Administration',
] as const;

export const GETAPP_PRICING_OPTIONS = [
  'Open Source',
  'One-Time License',
  'Subscription',
  'Free Trial',
] as const;
